"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MeetingSessionConfiguration_1 = require("../meetingsession/MeetingSessionConfiguration");

var MeetingSessionCredentials_1 = require("../meetingsession/MeetingSessionCredentials");

var DefaultModality_1 = require("../modality/DefaultModality");

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var Types_1 = require("../utils/Types");

var ContentShareConstants_1 = require("./ContentShareConstants");

var DefaultContentShareController = /*#__PURE__*/function () {
  function DefaultContentShareController(mediaStreamBroker, contentAudioVideo, attendeeAudioVideo) {
    _classCallCheck(this, DefaultContentShareController);

    this.mediaStreamBroker = mediaStreamBroker;
    this.contentAudioVideo = contentAudioVideo;
    this.attendeeAudioVideo = attendeeAudioVideo;
    this.observerQueue = new Set();
    this.destroyed = false;
    this.contentAudioVideo.addObserver(this);
    this.setupContentShareEvents();
  }

  _createClass(DefaultContentShareController, [{
    key: "setContentAudioProfile",
    value: function setContentAudioProfile(audioProfile) {
      this.contentAudioVideo.setAudioProfile(audioProfile);
    }
  }, {
    key: "startContentShare",
    value: function startContentShare(stream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this = this;

        var i;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (stream) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.mediaStreamBroker.mediaStream = stream;

                for (i = 0; i < this.mediaStreamBroker.mediaStream.getTracks().length; i++) {
                  this.mediaStreamBroker.mediaStream.getTracks()[i].addEventListener('ended', function () {
                    _this.stopContentShare();
                  });
                }

                this.contentAudioVideo.start();

                if (this.mediaStreamBroker.mediaStream.getVideoTracks().length > 0) {
                  this.contentAudioVideo.videoTileController.startLocalVideoTile();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "startContentShareFromScreenCapture",
    value: function startContentShareFromScreenCapture(sourceId, frameRate) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var mediaStream;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.mediaStreamBroker.acquireScreenCaptureDisplayInputStream(sourceId, frameRate);

              case 2:
                mediaStream = _context2.sent;
                _context2.next = 5;
                return this.startContentShare(mediaStream);

              case 5:
                return _context2.abrupt("return", mediaStream);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "pauseContentShare",
    value: function pauseContentShare() {
      if (this.mediaStreamBroker.toggleMediaStream(false)) {
        this.forEachContentShareObserver(function (observer) {
          Types_1.Maybe.of(observer.contentShareDidPause).map(function (f) {
            return f.call(observer);
          });
        });
      }
    }
  }, {
    key: "unpauseContentShare",
    value: function unpauseContentShare() {
      if (this.mediaStreamBroker.toggleMediaStream(true)) {
        this.forEachContentShareObserver(function (observer) {
          Types_1.Maybe.of(observer.contentShareDidUnpause).map(function (f) {
            return f.call(observer);
          });
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.contentAudioVideo) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                this.destroyed = true;
                this.contentAudioVideo.removeObserver(this);
                this.stopContentShare();
                this.observerQueue.clear();
                this.contentAudioVideo = undefined;
                this.attendeeAudioVideo = undefined;
                this.mediaStreamBroker = undefined;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "stopContentShare",
    value: function stopContentShare() {
      this.contentAudioVideo.stop();
      this.mediaStreamBroker.cleanup();
    }
  }, {
    key: "addContentShareObserver",
    value: function addContentShareObserver(observer) {
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeContentShareObserver",
    value: function removeContentShareObserver(observer) {
      this.observerQueue.delete(observer);
    }
  }, {
    key: "forEachContentShareObserver",
    value: function forEachContentShareObserver(observerFunc) {
      var _this2 = this;

      var _iterator = _createForOfIteratorHelper(this.observerQueue),
          _step;

      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this2.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "audioVideoDidStop",
    value: function audioVideoDidStop(_sessionStatus) {
      // If the content attendee got dropped or could not connect, stopContentShare will not be called
      // so make sure to clean up the media stream.
      this.mediaStreamBroker.cleanup();

      if (this.contentShareTile) {
        this.attendeeAudioVideo.videoTileController.removeVideoTile(this.contentShareTile.id());
        this.contentShareTile = null;
      }

      this.forEachContentShareObserver(function (observer) {
        Types_1.Maybe.of(observer.contentShareDidStop).map(function (f) {
          return f.call(observer);
        });
      });
    }
  }, {
    key: "setupContentShareEvents",
    value: function setupContentShareEvents() {
      var _this3 = this;

      // We use realtimeSubscribeToAttendeeIdPresence instead of audioVideoDidStart because audioVideoDidStart fires
      // before the capacity check in Tincan while when realtimeSubscribeToAttendeeIdPresence fires, we know the
      // content attendee has been able to pass the capacity check and join the call so we can start the local
      // content share video
      this.attendeeAudioVideo.realtimeController.realtimeSubscribeToAttendeeIdPresence(function (attendeeId, present, _externalUserId, _dropped) {
        var isContentAttendee = new DefaultModality_1.default(attendeeId).hasModality(DefaultModality_1.default.MODALITY_CONTENT);

        var isSelfAttendee = new DefaultModality_1.default(attendeeId).base() === _this3.attendeeAudioVideo.configuration.credentials.attendeeId;

        if (!isContentAttendee || !isSelfAttendee || !present || _this3.contentShareTile) {
          return;
        }

        var stream = _this3.mediaStreamBroker.mediaStream;

        if (stream === null || stream === void 0 ? void 0 : stream.getVideoTracks().length) {
          _this3.contentShareTile = _this3.attendeeAudioVideo.videoTileController.addVideoTile();
          var track = stream.getVideoTracks()[0];
          var width, height;

          if (track.getSettings) {
            var cap = track.getSettings();
            width = cap.width;
            height = cap.height;
          } else {
            var _cap = track.getCapabilities();

            width = _cap.width;
            height = _cap.height;
          }

          _this3.contentShareTile.bindVideoStream(_this3.contentAudioVideo.configuration.credentials.attendeeId, false, stream, width, height, null, _this3.contentAudioVideo.configuration.credentials.externalUserId);
        }

        _this3.forEachContentShareObserver(function (observer) {
          Types_1.Maybe.of(observer.contentShareDidStart).map(function (f) {
            return f.call(observer);
          });
        });
      });
    }
  }], [{
    key: "createContentShareMeetingSessionConfigure",
    value: function createContentShareMeetingSessionConfigure(configuration) {
      var contentShareConfiguration = new MeetingSessionConfiguration_1.default();
      contentShareConfiguration.meetingId = configuration.meetingId;
      contentShareConfiguration.externalMeetingId = configuration.externalMeetingId;
      contentShareConfiguration.urls = configuration.urls;
      contentShareConfiguration.credentials = new MeetingSessionCredentials_1.default();
      contentShareConfiguration.credentials.attendeeId = configuration.credentials.attendeeId + ContentShareConstants_1.default.Modality;
      contentShareConfiguration.credentials.externalUserId = configuration.credentials.externalUserId;
      contentShareConfiguration.credentials.joinToken = configuration.credentials.joinToken + ContentShareConstants_1.default.Modality;
      return contentShareConfiguration;
    }
  }]);

  return DefaultContentShareController;
}();

exports.default = DefaultContentShareController;